import React from 'react';

const Signup = () => {
    return (
        <div>
            <h2>This is Signup</h2>
        </div>
    );
};

export default Signup;